import { unwrap, withSignal } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { LogisticsClient } from "@nexxt/logistics-ui";
import { api } from "./api";

// The vendor return screens on gateway-backstage (ADR-229): one call per operation, input and answer of its contract.
// The supplier's answer is here too, for the administrator of Tomorrow who answers for a supplier without Atelier
// (ADR-227 point 5); Tomorrow's own writes (opening, Operations' decision, withdrawing, the messages again) are in
// features/vendor-return.

const returns = api.logistics["vendor-returns"];
const byId = returns[":vendorReturnId"];

export const logisticsClient: LogisticsClient = {
  listVendorReturns: (input, signal) => unwrap(returns.$get({ query: filterQuery(input) }, withSignal(signal))),
  getVendorReturn: (param, signal) => unwrap(byId.$get({ param }, withSignal(signal))),
  confirmVendorReturn: ({ vendorReturnId, version }) =>
    unwrap(byId.confirm.$post({ param: { vendorReturnId }, json: { version } })),
  refuseVendorReturn: ({ vendorReturnId, ...json }) => unwrap(byId.refuse.$post({ param: { vendorReturnId }, json })),
};
